import { WabunkaExperiencePreReservationPrice } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_pre_reservation_price';

import { useCurrency } from '@/wabunka-src/common/composables/general/useCurrency/useCurrency';
import {
  buildExperiencePreReservationPriceCalculateRequest,
  buildExperiencePreReservationPriceViewModel,
  createDefaultExperiencePreReservationPriceViewModel,
} from '@/wabunka-src/features/Experience';
import type { WabunkaReservationForm } from '@/wabunka-src/features/Experience';

/**
 * 料金テーブルの計算
 */
export const useWabunkaExperiencePreReservationPriceCalculations = () => {
  const { selectedCurrency } = useCurrency();

  const calculate = async (form: Ref<WabunkaReservationForm>, currency?: string) => {
    const path = ref(`/experiencePreReservationPrices/calculate`);
    const resolvedCurrency = currency ?? selectedCurrency.value;
    const requestBody = computed(() => {
      return buildExperiencePreReservationPriceCalculateRequest(form.value, false, resolvedCurrency);
    });

    // Nuxt 4 では同じ key のキャッシュが共有されるため、呼び出し毎にユニークな key を生成して
    // 常に最新の form 状態で再計算させる（POST のレスポンスをキャッシュすると古い料金が返る）
    const uniqueKey = `${path.value}-${resolvedCurrency}-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    const { data, error, status, execute, refresh } = await useFetchToPublicWabunkaApi({
      path,
      key: uniqueKey,
      body: requestBody,
      method: ref('POST'),
      options: { server: false },
      converter: WabunkaExperiencePreReservationPrice.fromJSON,
    });

    const preReservationPrice = computed(() => (data.value ? buildExperiencePreReservationPriceViewModel(data.value) : createDefaultExperiencePreReservationPriceViewModel()));
    return { preReservationPrice, error, status, execute, refresh };
  };

  return { calculate };
};
